import { render, staticRenderFns } from "./SignupBusinessDetail.vue?vue&type=template&id=65128f69&scoped=true"
import script from "./SignupBusinessDetail.vue?vue&type=script&lang=ts"
export * from "./SignupBusinessDetail.vue?vue&type=script&lang=ts"
import style0 from "./SignupBusinessDetail.vue?vue&type=style&index=0&id=65128f69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65128f69",
  null
  
)

export default component.exports